import { useContext, useEffect, useState } from 'react'
import PromoteChanges from '../../components/promote_changes'
import PromotedBranchStore from '../../components/promote_changes/context/context'
import { getRequest } from '../../services/base'
import { NavContext } from '../../context/global_context'
import { getSessionStorageData } from '../../utils/SessionStorage'
import { createSearchParams } from 'react-router-dom'
import Button from '../../components/common/Button'
import { useThemeContext } from '../../context/theme_context'
import { DARK_MODE } from '../../constants'

const PromoteChangesPage = () => {
  let [showPromoteChanges, setShowPromoteChanges] = useState(false)
  const [navState, navDispatch] = useContext(NavContext)
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`
  const { mode } = useThemeContext()

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: 'Manage your Updates list',
        sub_header:
          'You can define a list of Updates to push to Github new tracer-data version',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })

    validate()
  }, [])

  const validate = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Loading Data ...',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(`/api/pre/promote_changes/validate/`)
    setShowPromoteChanges(res?.data)
    navDispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  return showPromoteChanges ? (
    <PromotedBranchStore>
      <PromoteChanges />
    </PromotedBranchStore>
  ) : (
    <div
      className={`flex flex-col py-3 space-y-6 w-full justify-center ${mode === DARK_MODE ? 'text-white' : 'text-black'} h-50`}
    >
      <div className="text-xl">
        Branch not exists, are you sure want to continue with creation of new
        branch?
      </div>
      <div>
        <Button
          type="submit"
          className={`cursor-pointer btn`}
          text={'Continue'}
          onClick={() => {
            setShowPromoteChanges(true)
          }}
        />
      </div>
    </div>
  )
}
export default PromoteChangesPage
